module.exports = __webpack_public_path__ + "static/media/fabiano_sabha_walczak.1399a8ae.jpg";